/*--------------------------------
about のメインビジュアルの斜めストライプ

以前の js/about.js（jQuery + svg.js）を素の JS に置き換えたもの。
clipPath 内の rect を伸ばしていき、#bgAnimeAbout（clip-path: url(#customClip)）を見せていく。
動きは svg.js 版と同じ（ease も svg.js の既定 '>' = sin カーブ）。
--------------------------------*/

const SVG_NS = 'http://www.w3.org/2000/svg';

// svg.js の既定のイージング '>'
const easeOut = (pos) => Math.sin(pos * Math.PI / 2);

export function bars() {
	const box = document.getElementById('customSvgBox');
	if (!box) return;

	const www = window.innerWidth;
	const hhh = window.innerHeight;

	let space, space2, totalX, startX, randomAnimeMax, randomAnimeMin;
	const randomDelayMax = 600;
	const randomDelayMin = 0;

	if (www > 719) {
		space = 250;
		space2 = 60;
		totalX = Math.ceil((www * 3) / space);
		startX = -www;
		randomAnimeMax = 2000;
		randomAnimeMin = 600;
	} else {
		space = 120;
		space2 = 30;
		totalX = Math.ceil((hhh * 3) / space);
		startX = -hhh;
		randomAnimeMax = 1600;
		randomAnimeMin = 200;
	}

	const delayTIme = 0;
	const delayTIme2 = 600;
	const root2 = 1.5;
	const barH = hhh * root2 + space * root2 * 1.3;

	const svg = document.createElementNS(SVG_NS, 'svg');
	svg.id = 'customSvg';
	const defs = document.createElementNS(SVG_NS, 'defs');
	const clip = document.createElementNS(SVG_NS, 'clipPath');
	clip.id = 'customClip';
	defs.appendChild(clip);
	svg.appendChild(defs);

	const bars = [];

	[-45, 45].forEach((angle) => {
		for (let i = 0; i < totalX; i++) {
			const x = startX + i * space;
			const y = -space;

			const rect = document.createElementNS(SVG_NS, 'rect');
			rect.setAttribute('x', x);
			rect.setAttribute('y', y);
			rect.setAttribute('width', 1);
			rect.setAttribute('height', 1);
			rect.setAttribute('fill', '#fff');
			// svg.js の rotate() と同じく、作成時点の中心で回転
			rect.setAttribute('transform', `rotate(${angle} ${x + 0.5} ${y + 0.5})`);
			clip.appendChild(rect);

			const anime = Math.random() * (randomAnimeMax - randomAnimeMin) + randomAnimeMin + delayTIme2;
			const delay = Math.random() * (randomDelayMax - randomDelayMin) + randomDelayMin + delayTIme2 + delayTIme;

			bars.push({ rect, x, delay, anime, done: false });
		}
	});

	box.appendChild(svg);

	// Safari で clip-path の中身の変化が再描画されない対策（以前の setInterval 1ms の代わり）
	// 幅を毎フレーム揺らすとレイアウトが走るので Safari だけで行う
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	const target = isSafari ? document.getElementById('bgAnimeAbout') : null;
	let flip = false;

	const startTime = performance.now();

	function frame(now) {
		const t = now - startTime;
		let running = false;

		bars.forEach((bar) => {
			if (bar.done) return;
			running = true;

			const t1 = t - bar.delay;
			if (t1 < 0) return;

			const { rect, x, anime } = bar;
			const anime2 = anime / 2;

			if (t1 < anime) {
				// 1 段目: 1x1 → space2 x barH
				const p = easeOut(t1 / anime);
				rect.setAttribute('width', 1 + (space2 - 1) * p);
				rect.setAttribute('height', 1 + (barH - 1) * p);
			} else {
				// 2 段目: 幅を space2 → space にしつつ左へ space/2 移動
				const p = easeOut(Math.min((t1 - anime) / anime2, 1));
				rect.setAttribute('width', space2 + (space - space2) * p);
				rect.setAttribute('height', barH);
				rect.setAttribute('x', x - (space / 2) * p);

				if (t1 >= anime + anime2) bar.done = true;
			}
		});

		if (target) {
			flip = !flip;
			target.style.width = flip ? '100.1vw' : '100vw';
		}

		if (running) {
			requestAnimationFrame(frame);
		} else if (target) {
			target.style.width = '';
		}
	}
	requestAnimationFrame(frame);

	setTimeout(function () {
		document.querySelector(".aboutVisual .overArea .ttl")?.classList.add("active");
	}, 800 + delayTIme + delayTIme2);

	setTimeout(function () {
		document.querySelector(".aboutVisual .overArea .desp01")?.classList.add("active");
	}, 1600 + delayTIme + delayTIme2);
}
